// extracted by mini-css-extract-plugin
export default {"MainCont":"Mixing_MainCont__vfAeR","LeftCont":"Mixing_LeftCont__b9HYp","RightCont":"Mixing_RightCont__cDP87"};